<form [formGroup]="form" (ngSubmit)="addProtocol()">
  <div class="edit-actions-logistincs">
    <mat-spinner *ngIf="loadingAction" matSuffix [diameter]="20"></mat-spinner>
    <button *ngIf="!loadingAction" matTooltip="Cancelar" type="button" (click)="cancel()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
    <button *ngIf="!loadingAction" matTooltip="Enviar" type="button" (click)="send()" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
  </div>
  <div class="card-base  margin-botton-medium">
    <div class="card-content-logistics">
      <div class="card-container mat-elevation-z1">
        <div class="card-content">
          <mat-spinner *ngIf="loading" matSuffix></mat-spinner>
          <div *ngIf="!loading">
            <div class="card-box-medium margin-right-small">
              <h4>Configuración</h4>
              <mat-divider></mat-divider>
              <div formGroupName="StudyReportBatch" class="margin-top-medium">
                <mat-form-field class="full-width">
                  <input type="text" matInput placeholder="Sector origen" formControlName="SectorSend" required [matAutocomplete]="autSectorSend">
                  <mat-autocomplete #autSectorSend="matAutocomplete" [displayWith]="filterCompleteSectorSend.displayFn">
                    <mat-option *ngFor="let sectorFilter of filteredSectorSendOptions | async" [value]="sectorFilter">
                      {{sectorFilter.Name}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="fStudyReportBatch.SectorSend.errors && fStudyReportBatch.SectorSend.errors.required">
                    Seleccione un sector origen
                  </mat-error>
                </mat-form-field>


                <mat-form-field class="full-width">
                  <input type="text" #sectorReceiver matInput placeholder="Sector destino" formControlName="SectorReceiver" required [matAutocomplete]="autSectorReceiver">
                  <mat-autocomplete #autSectorReceiver="matAutocomplete" [displayWith]="filterCompleteSectorReceiver.displayFn">
                    <mat-option *ngFor="let sectorFilter of filteredSectorReceiverOptions | async" [value]="sectorFilter">
                      {{sectorFilter.Name}}
                    </mat-option>
                  </mat-autocomplete>
                  <mat-error *ngIf="fStudyReportBatch.SectorReceiver.errors && fStudyReportBatch.SectorReceiver.errors.required">
                    Seleccione un sector origen
                  </mat-error>
                </mat-form-field>
              </div>
              <mat-form-field class="full-width">
                <input autocomplete="off" type="text" #newProtocol matInput placeholder="Protocolo" formControlName="NewProtocol" required>
                <mat-error *ngIf="f.NewProtocol.errors && f.NewProtocol.errors.required">
                  Ingrese el protocolo
                </mat-error>


              </mat-form-field>

              <div class="edit-actions-logistincs margin-botton-medium">
                <button *ngIf="!loadingAction" type="submit" mat-icon-button mat-mini-fab>
                  <mat-icon>add</mat-icon>
                </button>
              </div>
            </div>

            <div class="card-box-medium">
              <h4>Protocolos</h4>
              <mat-divider></mat-divider>
              <table mat-table class="search-table margin-botton-medium" *ngIf="studyReportItemsForm.controls.length > 0"
                     [dataSource]="dataSource" formArrayName="StudyReportBatchItems">
                <tr mat-header-row class="search-table-header" *matHeaderRowDef="displayColumns"></tr>
                <tr mat-row class="search-table-cell" *matRowDef="let row; let i = index; columns: displayColumns;"></tr>

                <ng-container matColumnDef="Protocol">
                  <th mat-header-cell class="table-header" *matHeaderCellDef> Protocolo </th>
                  <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index">
                    {{displayProtocol(index)}}
                  </td>
                </ng-container>

                <ng-container matColumnDef="buttons">
                  <th mat-header-cell *matHeaderCellDef></th>
                  <td mat-cell class="table-cell" *matCellDef="let row; let index = index" [formGroupName]="index" (click)="$event.stopPropagation()">
                    <mat-icon class="cursor-default" (click)="onDeleteProtocol(index)">delete</mat-icon>
                  </td>
                </ng-container>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
